import React, { ReactElement } from 'react';

import { css } from '@emotion/react';

import { palette } from '@lib/styles/palette';
import pixelToRem from '@lib/styles/pixelToRem';

import ChartGraph from './ChartGraph';

interface PriceGraphProp {
  averagePrices:
    | {
        date: typeof Date;
        price: number;
        properMaxPrice: number;
        properMinPrice: number;
        standardPrice: number;
        stdDevPrice: number;
      }[]
    | undefined;
}

function PriceGraph({ averagePrices }: PriceGraphProp): ReactElement {
  const priceInfos = averagePrices?.map(({ price }) => price) ?? [0, 0, 0, 0];
  const todayPrice = new Intl.NumberFormat().format(priceInfos[3]);

  return (
    <div css={graphWrapperStyle}>
      <div className="graphTitle">
        <h2>시세금액</h2>
        <p>{todayPrice}원</p>
      </div>
      {/* 재사용을 위해 graph를 별도로 분리하였음 */}
      <ChartGraph averagePrices={averagePrices} />
    </div>
  );
}

export default PriceGraph;

const graphWrapperStyle = css`
  border: 1px solid ${palette.gray2};
  border-radius: 4px;
  width: clamp(400px, 100%, 600px);
  height: 376px;
  position: relative;
  display: flex;
  flex-direction: column;
  padding: ${pixelToRem(72, 60, 56, 60)};

  .graphTitle {
    display: flex;
    flex-direction: column;

    h2 {
      color: ${palette.gray6};
      font-size: 14px;
      line-height: 20px;
      margin-bottom: 8px;
    }

    p {
      font-size: 28px;
      color: ${palette.orange9};
      line-height: 34px;
    }
  }

  .canvas-container {
    margin-top: 29px;
    align-self: flex-end;
  }

  /** mobile */
  @media (max-width: 599px) {
    padding: ${pixelToRem(20, 20, 0, 20)};
    width: 100%;
    border: none;

    .graphTitle {
      margin-top: ${pixelToRem(36)};
    }
  }

  /** tablet */
  @media (min-width: 600px) and (max-width: 1023px) {
    padding: ${pixelToRem(20, 20, 0, 20)};
    width: 100%;
    border: none;
    flex-direction: row;

    .graphTitle {
      margin-top: ${pixelToRem(36)};
      margin-right: ${pixelToRem(43)};
      display: flex;
      flex-direction: column;
      flex: 1 0 auto;
    }
  }

  /** PC */
  @media (min-width: 1024px) {
    canvas {
      max-width: 329px !important;
    }
  }
`;
